module.exports = __webpack_public_path__ + "static/media/gatot-2.3955a8a1.jpg";